// extracted by mini-css-extract-plugin
export default {"box":"BlockUser_box__vJuzu","selectTitle":"BlockUser_selectTitle__1ELcK","title":"BlockUser_title__s+VNw","inputTitle":"BlockUser_inputTitle__w3hhJ"};